export default __webpack_public_path__ + "static/media/Pranav.da9da8e6.jpeg";